import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Select from 'react-select';
import Constants from '../../config/constants';
import RelationDataTable from '../datatable/RelationDataTable';
import Thumbnail from '../thumbnail/Thumbnail';
import { COLUMN_STYLE, getColumnStyle, searchData } from '../datatable/util';
import {
  addCoolingTowerToACCentral,
  removeCoolingTowerFromACCentral,
  editCoolingTowerInACCentral,
  addToBeCreatedCoolingTower,
  editToBeCreatedCoolingTower,
  removeToBeCreatedCoolingTower,
} from '../../redux/ac_central/ac_central_actions';
import { searchCoolingTowerByText } from '../../redux/ac_central/cooling_tower_actions';
import { defaultRejectHandler } from '../../utils/utility';

export class CoolingTowerDataTable extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props;

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);
    const decimalColumn = getColumnStyle(COLUMN_STYLE.decimal);

    this.columns = [
      {
        Header: '',
        accessor: 'cooling_tower.thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'cooling_tower.name',
        ...textColumn,
        entity: {
          list: (text, page) => searchCoolingTowerByText(text, page)
            .then(response => response.data.map((cooling_tower) => ({label: cooling_tower.name, value: String(cooling_tower.id), original: cooling_tower}))),
          create: null,
        },
      },
      {
        Header: () => <b>{t('power (kW)')}</b>,
        accessor: 'cooling_tower.power_required',
        ...coeColumn,
        width: 120,
      },
      {
        Header: () => <b>{t('quantity')}</b>,
        accessor: 'quantity',
        ...decimalColumn,
        width: 80,
        attr: {
          type: 'number',
          isRequired: true,
          props: { min: 1 },
        },
      },
    ];

    this.state = {
      isShowCreateAC: false,
    };
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;
    if(filter!== undefined){
      this.setState({ search: filter })
    }
    this.setState({ categoryOption: category });
  }

  editItem(item) {
    this.setState({
        isShowEditModal: true,
        selectedItem: item.original,
      },
      () => {
        if (this.props.onEditItem) {
          this.props.onEditItem(this.state.selectedItem);
        }
      },
    );
  }


  render() {
    const {
      categoryOption,
      selectedItem: item,
      search,
    } = this.state;

    const {
      acCentralId,
      filtered,
      filteredCount,
      isLoading,
      addCoolingTower,
      removeCoolingTower,
      editCoolingTower,
      isCoolingTowerAdding,
      isCoolingTowerEditing,
      isCoolingTowerRemoving,
      coolingTowers,
      addToBeCreatedCoolingTower,
      editToBeCreatedCoolingTower,
      removeToBeCreatedCoolingTower,
      mode,
      t,
    } = this.props;

    const accessor = (data) => data && data.cooling_tower;

    const relationship = {
      create: (({entityId, quantity, original }) => {
        if (mode === 'edit'){
          addCoolingTower(acCentralId, entityId, quantity);
        } else{
          addToBeCreatedCoolingTower(quantity, original, this.props.coolingTowers);
        }
      }).bind(this),
      delete: (id, rel) => {
        if (mode === 'edit'){
          removeCoolingTower(id, acCentralId)
        } else{
          removeToBeCreatedCoolingTower(rel.cooling_tower.id);
        }
      },
      edit: ({ id, quantity, cooling_tower }) => {
        if (mode === 'edit'){
          editCoolingTower(id, quantity)
        } else{
          editToBeCreatedCoolingTower(cooling_tower.id, quantity)
        }
      },
      isCreating: isCoolingTowerAdding,
      isEditing: isCoolingTowerEditing,
      isDeleting: isCoolingTowerRemoving,
    };
    return (
      <div>
        <div style={{ backgroundColor: 'white' }}>
          <div className="filter-box" style={{ display: 'flex', padding: 20, marginBottom: 20 }}>
            <input
              className="text-search"
              style={{ width: 240, height: 36, margin: 10 }}
              type="text"
              onChange={event => this.updateSortFilter(event.target.value, null, categoryOption)}
              placeholder={t('search name')}
            />
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              style={{ width: 160, margin: 10 }}
              value={categoryOption}
              placeholder={t('category')}
              onChange={option => this.updateSortFilter(filtered, null, option)}
              options={[
                { value: 'all', label: t('all') },
                { value: 'public', label: t('public') },
                { value: 'private', label: t('private') },
              ]}
            />
          </div>
          <RelationDataTable
            columns={this.columns}
            data={searchData(search, categoryOption, coolingTowers, accessor)}
            relationship={relationship}
            relationshipNameAccessor={item => item.cooling_tower.name}
            classNamePrefix="select-central-unit-cooling-tower"
            onActionEdit={item => this.editItem(item)}
            onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
            filteredCount={filteredCount}
            isLoading={isLoading}
            onFetchData={state => this.updateSortFilter(filtered, state, categoryOption)}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  isCoolingTowerAdding: state.ac.central.isCoolingTowerAdding,
  isCoolingTowerEditing: state.ac.central.isCoolingTowerEditing,
  isCoolingTowerRemoving: state.ac.central.isCoolingTowerRemoving,
});

const mapDispatchToProps = dispatch => ({
  addCoolingTower: (acCentralId, coolingTowerId, quantity) => defaultRejectHandler(dispatch(addCoolingTowerToACCentral(acCentralId, coolingTowerId, quantity))),
  addToBeCreatedCoolingTower: (quantity, cooling_tower, tobecreatedcoolingtowerarry) => defaultRejectHandler(dispatch(addToBeCreatedCoolingTower(quantity, cooling_tower, tobecreatedcoolingtowerarry))),
  removeCoolingTower: (acCentralCoolingTowerId, acCentralId) => defaultRejectHandler(dispatch(removeCoolingTowerFromACCentral(acCentralCoolingTowerId, acCentralId))),
  removeToBeCreatedCoolingTower: (coolingTowerId) => defaultRejectHandler(dispatch(removeToBeCreatedCoolingTower(coolingTowerId))),
  editCoolingTower: (acCentralCoolingTowerId, quantity) => defaultRejectHandler(dispatch(editCoolingTowerInACCentral(acCentralCoolingTowerId, quantity))),
  editToBeCreatedCoolingTower: (coolingTowerId, quantity) => defaultRejectHandler(dispatch(editToBeCreatedCoolingTower(coolingTowerId, quantity)))
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(CoolingTowerDataTable),
);



// WEBPACK FOOTER //
// ./src/components/ac_central/CoolingTowerDataTable.js